<template>
  <JobCosts v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import { Filter } from "@/components/DatatableV3.vue";
import JobCosts from "@/Reports/JobCosts.vue";

const initialData = ref<{
  source: string;
  filters: Filter[];
} | null>(null);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });

  // The endpoint 404s when job_costing_ff_enabled is off, but the route still
  // resolves; parsing that body would reject unhandled and leave a blank page.
  if (!res.ok) return;

  initialData.value = await res.json();
});
</script>
